<template>
    <b-modal
        id="remarkModal"
        title="Add Remark"
        @hidden="resetModal"
        @ok="handleSubmit"
        ok-title="Save"
    >
        <b-form-textarea
            v-model="remark"
            placeholder="Write a remark..."
            rows="4"
        ></b-form-textarea>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            remark: '',
            contactId: null,
        };
    },
    methods: {
        async openRemarkModal(id) {
            this.contactId = id;
            try {
                const { data } = await axios.get(route('admin.contacts.show', id));
                this.remark = data.remark || '';
            } catch (e) {
                this.remark = '';
            }
            this.$bvModal.show('remarkModal');
        },
        resetModal() {
            this.remark = '';
            this.contactId = null;
        },
        handleSubmit(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.submitRemark();
        },
        async submitRemark() {
            try {
                await axios.post(route('admin.contacts.addRemark', this.contactId), {
                    remark: this.remark,
                });
                this.$swal('Saved!', 'Remark has been saved.', 'success');
                this.$bvModal.hide('remarkModal');
                reloadTable();
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
        async toggleStar(id) {
            try {
                await axios.get(route('admin.contacts.toggleStar', id));
                reloadTable();
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
        async deleteContact(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "This contact will be deleted.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await axios.delete(route('admin.contacts.destroy', id));
                        this.$swal({
                            title: 'Deleted!',
                            text: 'Contact has been deleted.',
                            icon: 'success',
                            didClose: () => reloadTable(),
                        });
                    } catch (e) {
                        this.$swal('Error!', '', 'error');
                    }
                }
            });
        },
    },
};
</script>
